import { Injectable } from '@angular/core';
import {SessionService} from './session.service';
import {MasterService} from './master.service';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  isInitCompleted$ = new BehaviorSubject<boolean>(false); // 初期化処理終了(master取得完了)を通知
  constructor(private sessionService: SessionService,
              private masterService: MasterService,) { }

  /**
   *
   */
  Init() {
    return new Promise<void>((resolve) => {
      setTimeout(async() => {
        const user = await this.sessionService.doAuth();
        if (!user) {
          console.log('login');
          resolve();
        }
        // const koushinDoc = await this.db.collection('masters').doc('forceUpdate').get().toPromise();
        // const koushin: any = koushinDoc.data();
        // const newVersion = koushin.version;
        // const currentVersion = localStorage.getItem('version');
        // if (newVersion !== currentVersion) {
        //   this.masterService.forceUpdate = true;
        //   console.log('force update!!!!');
        //   localStorage.setItem('version', newVersion);
        // }
        await this.masterService.getMasters();
        this.masterService.checkMasters();
        this.isInitCompleted$.next(true);
        resolve();
      }, 200);
    });
  }
}
